import PublicLayout from '@/components/public/PublicLayout';

export default function PoliticaPrivacidadPage() {
    return (
        <PublicLayout>
            <section className="relative overflow-hidden bg-gradient-candy text-[hsl(var(--kche-dark))] py-14">
                <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-white/40 blur-3xl" />
                <div className="relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                    <p className="text-sm font-bold font-display text-[hsl(var(--kche-pink))] uppercase tracking-wider">Legal</p>
                    <h1 className="mt-1 text-4xl sm:text-5xl font-display font-bold">Política de privacidad</h1>
                </div>
            </section>
            <section className="bg-background py-14">
                <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
                    <div className="rounded-3xl bg-white border border-border shadow-soft p-6 sm:p-8 prose prose-sm sm:prose-base max-w-none">
                        <p className="text-muted-foreground"><strong>TODO:</strong> el texto legal definitivo de la política de privacidad está pendiente de confirmación por el cliente. No publicamos contenido legal sin validación.</p>
                        <p>K\'che Diversiones Pifo recopila únicamente los datos que tú nos compartes voluntariamente en formularios de contacto o reservas. Usamos esa información para contactarte sobre nuestros servicios.</p>
                        <p>No compartimos tus datos con terceros sin tu autorización.</p>
                        <p>Para solicitudes sobre tus datos personales, escríbenos por nuestros canales oficiales.</p>
                    </div>
                </div>
            </section>
        </PublicLayout>
    );
}
